export default "__VITE_ASSET__2b51DteM__"